// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../public/images/spinner.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-pages-components-fullPageLoadingSpinner-spinner-module__spinner--jnape {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1100;
    background-color: #071c35;
    opacity: 0.7;
    filter: alpha(opacity=70);
    display: block;

    .src-js-pages-components-fullPageLoadingSpinner-spinner-module__image--VDT_I {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat;
        background-size: 36px 36px;
        width: 36px;
        height: 36px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -18px; /* -1 * image width / 2 */
        margin-top: -18px; /* -1 * image height / 2 */
        border: none;
      }
    
      .src-js-pages-components-fullPageLoadingSpinner-spinner-module__processing-msg--TBJUR {
        color: #f5f5f5;
        text-align: center;
        vertical-align: middle;
        line-height: 60;
      }
}`, "",{"version":3,"sources":["webpack://./src/js/pages/components/fullPageLoadingSpinner/spinner.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,yBAAyB;IACzB,cAAc;;IAEd;QACI,6DAAqE;QACrE,0BAA0B;QAC1B,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,kBAAkB,EAAE,yBAAyB;QAC7C,iBAAiB,EAAE,0BAA0B;QAC7C,YAAY;MACd;;MAEA;QACE,cAAc;QACd,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;MACjB;AACN","sourcesContent":[".spinner {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1100;\n    background-color: #071c35;\n    opacity: 0.7;\n    filter: alpha(opacity=70);\n    display: block;\n\n    .image {\n        background: url('../../../../../public/images/spinner.gif') no-repeat;\n        background-size: 36px 36px;\n        width: 36px;\n        height: 36px;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        margin-left: -18px; /* -1 * image width / 2 */\n        margin-top: -18px; /* -1 * image height / 2 */\n        border: none;\n      }\n    \n      .processing-msg {\n        color: #f5f5f5;\n        text-align: center;\n        vertical-align: middle;\n        line-height: 60;\n      }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": `src-js-pages-components-fullPageLoadingSpinner-spinner-module__spinner--jnape`,
	"image": `src-js-pages-components-fullPageLoadingSpinner-spinner-module__image--VDT_I`,
	"processing-msg": `src-js-pages-components-fullPageLoadingSpinner-spinner-module__processing-msg--TBJUR`
};
export default ___CSS_LOADER_EXPORT___;
